import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {
  CombinedFlight,
  FlightEnterpriseSearchInterface,
  ServiceProvider
} from '@sabstravtech/obtservices/base';
import { FlightItinerary } from '@sabstravtech/obtservices/angular';

import { LightningModalTypes } from '../../core/classes/modal-types.enum';

@Component({
  selector: 'app-gmt-flight-details-modal',
  templateUrl: './gmt-flight-details-modal.component.html',
  styleUrls: ['./gmt-flight-details-modal.component.scss'],
  standalone: false
})
export class GmtFlightDetailsModalComponent implements OnInit {
  flight: CombinedFlight = null;
  gmtSelectedFlightIndex: number = null;
  searchParams: FlightEnterpriseSearchInterface = null;
  isTravelfusion = false;
  index = 0;
  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {
    if (this.flight.flights[this.gmtSelectedFlightIndex].source === ServiceProvider.Travelfusion) {
      this.isTravelfusion = true;
    }
  }
  addToBasket(flight: FlightItinerary) {
    const selectedFlightIndex = this.flight.flights.findIndex(
      (item) => item.journeyHash === flight.journeyHash
    );
    if (this.searchParams.selectedFlight.value?.journeyHash !== flight.journeyHash) {
      this.searchParams.selectedFlight.next(flight);
      this.gmtSelectedFlightIndex = selectedFlightIndex;
    } else {
      this.searchParams.selectedFlight.next(null);
      this.gmtSelectedFlightIndex = null;
    }
  }

  close() {
    this.activeModal.close(this.gmtSelectedFlightIndex);
  }
}

LightningModalTypes.GmtFlightDetailsModalComponent.component = GmtFlightDetailsModalComponent;
